// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Router from "next/router";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.mjs";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as ExploreCmp$PorterinFeature from "../../../../ui/components/ExploreCmp.mjs";
import * as CommonHelper$PorterinFeature from "../../../core/helpers/CommonHelper.mjs";
import * as FormInputCmp$PorterinFeature from "../../../../ui/components/FormInputCmp.mjs";
import * as SharedHelper$PorterinFeature from "../../../core/helpers/SharedHelper.mjs";
import * as SubmitBtnCmp$PorterinFeature from "../../../../ui/components/SubmitBtnCmp.mjs";
import * as FareEstimateForm$PorterinFeature from "./form/FareEstimateForm.mjs";
import * as FareEstimateHelper$PorterinFeature from "../../../core/helpers/FareEstimateHelper.mjs";
import * as FareEstimateFormsModuleScss from "../styles/FareEstimateForms.module.scss";
import * as FareEstimateEventHelper$PorterinFeature from "../../../../containers/fare-estimate-v1/domain/helpers/FareEstimateEventHelper.mjs";
import * as FareEstimateSelectReqCmp$PorterinFeature from "./FareEstimateSelectReqCmp.mjs";
import * as AutocompleteDropdownStyles$PorterinFeature from "../../../auto-complete/view/styles/AutocompleteDropdownStyles.mjs";
import * as FareEstimateResultFormHelper$PorterinFeature from "../../../core/helpers/FareEstimateResultFormHelper.mjs";
import * as GoogleReactAutocompleteCmpMod$PorterinFeature from "../../../auto-complete/view/components/GoogleReactAutocompleteCmpMod.mjs";

var styles = FareEstimateFormsModuleScss;

function TwoWheelerFormFieldsCmp(Props) {
  var form = Props.form;
  var onChangeCategory = Props.onChangeCategory;
  var response = Props.response;
  var city_context = Props.city_context;
  var fare_estimate_vm = Props.fare_estimate_vm;
  var arrow_icon = Props.arrow_icon;
  var match = Router.useRouter();
  var locale = match.locale;
  var pickupAddressOnChange = function (addressValue, _postalAddress) {
    Curry._2(form.updatePickup_address, (function (input, value) {
            return {
                    pickup_address: value,
                    drop_address: input.drop_address,
                    name: input.name,
                    mobile: input.mobile,
                    requirement: input.requirement,
                    consent_for_callback: input.consent_for_callback
                  };
          }), addressValue);
  };
  var dropAddressOnChange = function (addressValue, _postalAddress) {
    Curry._2(form.updateDrop_address, (function (input, value) {
            return {
                    pickup_address: input.pickup_address,
                    drop_address: value,
                    name: input.name,
                    mobile: input.mobile,
                    requirement: input.requirement,
                    consent_for_callback: input.consent_for_callback
                  };
          }), addressValue);
  };
  var requirementOnChange = function ($$event) {
    var value = FareEstimateHelper$PorterinFeature.requirementfromString(FormHelper$Catalyst.TargetEventWrapper.value($$event));
    Curry._2(form.updateRequirement, (function (input, value) {
            return {
                    pickup_address: input.pickup_address,
                    drop_address: input.drop_address,
                    name: input.name,
                    mobile: input.mobile,
                    requirement: value,
                    consent_for_callback: input.consent_for_callback
                  };
          }), value);
  };
  var getFieldError = function (field, callback) {
    var match = Curry._1(form.dirty, undefined);
    if (response === undefined) {
      return CommonHelper$PorterinFeature.getError(field);
    }
    if (response.TAG === /* Ok */0) {
      return CommonHelper$PorterinFeature.getError(field);
    }
    var form_error = response._0;
    if (form_error.TAG === /* FareEstimateHashError */0 || match) {
      return CommonHelper$PorterinFeature.getError(field);
    } else {
      return Curry._1(callback, Belt_Option.getWithDefault(form_error._0.field_errors, FareEstimateForm$PorterinFeature.inital));
    }
  };
  var isFieldErrorOrResponseError = function (param) {
    if (SharedHelper$PorterinFeature.isError(form.pickup_addressResult) || SharedHelper$PorterinFeature.isError(form.drop_addressResult) || response !== undefined && response.TAG !== /* Ok */0) {
      return true;
    } else {
      return false;
    }
  };
  var match$1 = Curry._1(form.dirty, undefined);
  var tmp;
  if (response !== undefined && response.TAG !== /* Ok */0) {
    var form_error = response._0;
    tmp = form_error.TAG === /* FareEstimateHashError */0 ? (
        match$1 ? null : form_error._0
      ) : (
        match$1 ? null : Belt_Option.getWithDefault(form_error._0.form_error, "")
      );
  } else {
    tmp = null;
  }
  return React.createElement("form", {
              className: styles["form-container"],
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(form.submit, undefined);
                })
            }, React.createElement(FormInputCmp$PorterinFeature.make, {
                  label: fare_estimate_vm.labels.pickup,
                  is_required: true,
                  children: React.createElement(GoogleReactAutocompleteCmpMod$PorterinFeature.make, {
                        id: "pickup-address-" + String(Math.random()) + "",
                        value: form.input.pickup_address.landmark,
                        api_key: Config$PorterinUtils.google_maps_api_key,
                        form_on_change: pickupAddressOnChange,
                        placeholder: fare_estimate_vm.labels.pickup,
                        wrapperStyle: AutocompleteDropdownStyles$PorterinFeature.wrapperStyle,
                        menuStyle: AutocompleteDropdownStyles$PorterinFeature.menuStyle,
                        inputClass: "" + styles["pickup-input"] + " " + (
                          form.submitting ? styles.disabled : ""
                        ) + "",
                        itemClass: styles["dropdown-item"]
                      }),
                  error: FareEstimateResultFormHelper$PorterinFeature.getAddressFieldError(form.pickup_addressResult, (function (field_errors) {
                          return field_errors.pickup;
                        }), response, FareEstimateResultFormHelper$PorterinFeature.addressFieldError(Curry._1(form.dirty, undefined), /* Pickup */0, fare_estimate_vm.errors_msgs.pickup))
                }), React.createElement(FormInputCmp$PorterinFeature.make, {
                  label: fare_estimate_vm.labels.drop,
                  is_required: true,
                  children: React.createElement(GoogleReactAutocompleteCmpMod$PorterinFeature.make, {
                        id: "drop-address-" + String(Math.random()) + "",
                        value: form.input.drop_address.landmark,
                        api_key: Config$PorterinUtils.google_maps_api_key,
                        form_on_change: dropAddressOnChange,
                        placeholder: fare_estimate_vm.labels.drop,
                        wrapperStyle: AutocompleteDropdownStyles$PorterinFeature.wrapperStyle,
                        menuStyle: AutocompleteDropdownStyles$PorterinFeature.menuStyle,
                        inputClass: "" + styles["drop-input"] + " " + (
                          form.submitting ? styles.disabled : ""
                        ) + "",
                        itemClass: styles["dropdown-item"]
                      }),
                  error: FareEstimateResultFormHelper$PorterinFeature.getAddressFieldError(form.drop_addressResult, (function (field_errors) {
                          return field_errors.drop;
                        }), response, FareEstimateResultFormHelper$PorterinFeature.addressFieldError(Curry._1(form.dirty, undefined), /* Dropoff */1, fare_estimate_vm.errors_msgs.drop))
                }), React.createElement(FormInputCmp$PorterinFeature.make, {
                  label: fare_estimate_vm.labels.phone,
                  is_required: true,
                  children: React.createElement("input", {
                        className: styles["mobile-input"],
                        disabled: form.submitting,
                        placeholder: fare_estimate_vm.labels.phone,
                        type: "tel",
                        value: form.input.mobile,
                        onBlur: (function (param) {
                            Curry._1(form.blurMobile, undefined);
                          }),
                        onChange: (function ($$event) {
                            Curry._2(form.updateMobile, (function (input, value) {
                                    return {
                                            pickup_address: input.pickup_address,
                                            drop_address: input.drop_address,
                                            name: input.name,
                                            mobile: value,
                                            requirement: input.requirement,
                                            consent_for_callback: input.consent_for_callback
                                          };
                                  }), $$event.target.value);
                          })
                      }),
                  error: getFieldError(form.mobileResult, (function (field_errors) {
                          return field_errors.mobile;
                        }))
                }), React.createElement(FormInputCmp$PorterinFeature.make, {
                  label: fare_estimate_vm.labels.name,
                  is_required: true,
                  children: React.createElement("input", {
                        className: styles["name-input"],
                        disabled: form.submitting,
                        placeholder: fare_estimate_vm.labels.name,
                        type: "text",
                        value: form.input.name,
                        onBlur: (function (param) {
                            Curry._1(form.blurName, undefined);
                          }),
                        onChange: (function ($$event) {
                            Curry._2(form.updateName, (function (input, value) {
                                    return {
                                            pickup_address: input.pickup_address,
                                            drop_address: input.drop_address,
                                            name: value,
                                            mobile: input.mobile,
                                            requirement: input.requirement,
                                            consent_for_callback: input.consent_for_callback
                                          };
                                  }), $$event.target.value);
                          })
                      }),
                  error: getFieldError(form.nameResult, (function (field_errors) {
                          return field_errors.name;
                        }))
                }), React.createElement(FareEstimateSelectReqCmp$PorterinFeature.make, {
                  requirement: form.input.requirement,
                  onChange: requirementOnChange,
                  disabled: form.submitting,
                  label: fare_estimate_vm.labels.requirement,
                  is_required: true,
                  error: getFieldError(form.requirementResult, (function (field_errors) {
                          return field_errors.requirement;
                        })),
                  requirement_labels: fare_estimate_vm.requirement_labels
                }), isFieldErrorOrResponseError(undefined) ? React.createElement(ExploreCmp$PorterinFeature.make, {
                    onChangeCategory: onChangeCategory,
                    arrow_icon: arrow_icon
                  }) : null, React.createElement("div", {
                  className: styles["checkbox-input"],
                  onClick: (function (param) {
                      Curry._2(form.updateConsent_for_callback, (function (input, param) {
                              return {
                                      pickup_address: input.pickup_address,
                                      drop_address: input.drop_address,
                                      name: input.name,
                                      mobile: input.mobile,
                                      requirement: input.requirement,
                                      consent_for_callback: !form.input.consent_for_callback
                                    };
                            }), form.input.consent_for_callback);
                    })
                }, React.createElement("input", {
                      checked: form.input.consent_for_callback,
                      name: "whatspp-consent",
                      type: "checkbox"
                    }), React.createElement("p", {
                      className: styles.text
                    }, fare_estimate_vm.consent_label)), React.createElement(SubmitBtnCmp$PorterinFeature.make, {
                  is_disabled: !Curry._1(form.valid, undefined) || form.submitting,
                  className: styles["submit-container"],
                  icon_label: fare_estimate_vm.submit_icon_label,
                  category: city_context.category,
                  call_back: (function (param) {
                      SharedHelper$PorterinFeature.triggerAcceptAllCookies(locale);
                    }),
                  event_name: FareEstimateEventHelper$PorterinFeature.submitButtonGaEvent(city_context.category, /* TwoWheelers */0)
                }), React.createElement("div", {
                  className: styles["form-error-container"]
                }, tmp));
}

var make = TwoWheelerFormFieldsCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
